import {HTMLAttributes} from 'react'
import {cn} from '@utilities/helpers'

export type StatusDotVariant = 'danger' | 'warning' | 'blue' | 'success' | 'neutral' | 'purple'

const STATUS_DOT_VARIANT_CLASSNAME = {
    danger: 'bg-danger-500',
    warning: 'bg-warning-500',
    blue: 'bg-blue-500',
    purple: 'bg-purple-500',
    neutral: 'bg-neutral-500',
    success: 'bg-success-500'
} as const satisfies Record<StatusDotVariant, string>

export const StatusDot = ({
    variant,
    className,
    ...props
}: HTMLAttributes<HTMLDivElement> & {variant: StatusDotVariant}) => (
    <div
        className={cn('h-2.5 w-2.5 rounded-full shrink-0', STATUS_DOT_VARIANT_CLASSNAME[variant], className)}
        {...props}
    />
)
